const LABORAL_HISTORIC_SCHEMA_DEPENDENCIES = new Map<string, readonly string[]>([
  ['analisis-coordinador', ['alta-incidencia']],
  ['analisis-laboral', ['alta-incidencia']],
  ['carta', ['analisis-laboral']],
  ['envio-buromail', ['carta']],
  ['cargar-justificativo', ['envio-buromail']],
  ['alta-sanciones', ['envio-buromail']],
]);

const INHERITED_ALTA_INCIDENCIA_ADDITIONAL_VARIABLE_NAMES = [
  'coordinador_name',
  'coordinador_email',
] as const;

const LABORAL_HISTORIC_ADDITIONAL_VARIABLE_NAMES = new Map<string, readonly string[]>([
  ['analisis-coordinador', [
    ...INHERITED_ALTA_INCIDENCIA_ADDITIONAL_VARIABLE_NAMES,
    'historialChat',
  ]],
  ['analisis-laboral', [
    ...INHERITED_ALTA_INCIDENCIA_ADDITIONAL_VARIABLE_NAMES,
    'historialChat',
  ]],
  ['carta', [
    ...INHERITED_ALTA_INCIDENCIA_ADDITIONAL_VARIABLE_NAMES,
    'carta_anterior',
  ]],
  ['envio-buromail', INHERITED_ALTA_INCIDENCIA_ADDITIONAL_VARIABLE_NAMES],
  ['cargar-justificativo', INHERITED_ALTA_INCIDENCIA_ADDITIONAL_VARIABLE_NAMES],
  ['alta-sanciones', INHERITED_ALTA_INCIDENCIA_ADDITIONAL_VARIABLE_NAMES],
]);

export function getLaboralHistoricSchemaKeys(formKey: string): string[] {
  const resolved: string[] = [];
  const visited = new Set<string>();

  const visit = (schemaKey: string) => {
    if (visited.has(schemaKey)) return;
    visited.add(schemaKey);

    for (const dependency of LABORAL_HISTORIC_SCHEMA_DEPENDENCIES.get(schemaKey) ?? []) {
      visit(dependency);
    }
    resolved.push(schemaKey);
  };

  visit(formKey);
  return resolved;
}

export function getLaboralHistoricAdditionalVariableNames(formKey: string): string[] {
  return [...(LABORAL_HISTORIC_ADDITIONAL_VARIABLE_NAMES.get(formKey) ?? [])];
}
